import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ErrorMessage } from '@library/common/http';

let ID = 0;

@Injectable({
   providedIn: 'root',
})
export class ErrorMessageService {
   messages: BehaviorSubject<ErrorMessage[]> = new BehaviorSubject( [] );

   get errors() {
      return this.messages.pipe( map( message => message.filter( m => m.type === 'error' )));
   }

   get none(): boolean {
      return !this.messages.getValue().length;
   }

   get maintenance(): boolean {
      const messages = this.messages.getValue()
         .filter( m => m.type === 'error' )
         .map( m => m.code )
         .filter( code => code === 'maintenance' );

      return !!messages.length;
   }

   reset(): void {
      console.log( 'error reset called' );
      this.messages.next( [] );
   }

   resetErrors(): void {
      this.messages.next( this.messages.getValue().filter( e => e.type !== 'error' ));
   }

   clear( id: number ): void {
      const ms = this.messages.getValue();
      this.messages.next( ms.filter( m => m.id !== id ));

      const message = ms.filter( m => m.id === id )[0];
      if ( message?.callback ) {
         message.callback();
      }
   }

   push( message: string ): void {
      const current = this.messages.getValue();
      if ( current.map( e => e.message ).includes( message )) { return; }

      current.push( new ErrorMessage({
         id: ++ID,
         type: 'error',
         code: 'Default',
         message,
         timestamp: new Date(),
      }));

      this.messages.next( current );
   }

   add( message: ErrorMessage ): void {
      const current = this.messages.getValue();
      if ( current.map( e => e.message ).includes( message.message )) { return; }

      this.messages.next([ ...current, ({ ...message, id: ++ID, timestamp: message.timestamp ?? new Date() }) ]);
   }
}
